export default __webpack_public_path__ + "static/media/support.74ef03ee.jpg";